import { DateIn } from 'Input/DateIn';
import { DateOut } from 'Input/DateOut';
import { Typography, Stack } from '@mui/material';

const Housing = () => {
  return (<Stack spacing={1}>
      
        <Typography variant='body1' component='h1' textAlign='center'>
        These inputs indicate when your cattle are housed and their manure is being collected as slurry.
         <br></br>  'Date In' is when the cattle enter housing, and 'Date Out' is when they leave.
        </Typography>
    <>
      <DateIn/>  
      <DateOut/>  
    </>
    </Stack>
  );
}

export default Housing;
